import Vue from "vue";

export const store = Vue.observable({
  noError: true,
  errorMessage: "",
  info: {
    row_no: "",
    client_cd: "",
    client_di: "",
    parentclient_cd: "",
    client_na: "",
    clientsub_na: "",
    ndstaff_na: "",
    npc_cd: "",
    nohinsyo_fg: "",
    ndnetbill_fg: "",
    bp_kbn: "",
    contracted_fg: "",
    orderapprove_fg: "",
    orderapprover_skip_fg: "",
    defaultclient_cd: "",
    loginuser_id: "",
    loginuser_na: "",
    tan_role: "",
    comuser_fg: "",
    comuid_na: "",
    auth_order_nomal: "",
    auth_order_file: "",
    auth_order_approval: "",
    auth_req_estimate: "",
    auth_req_sample: "",
    auth_req_catalogue: "",
    auth_req_envdocument: "",
    auth_req_parametersheet: "",
    auth_ref_order: "",
    auth_ref_orderrest: "",
    auth_ref_purchaseresults: "",
    auth_ref_inventory: "",
    auth_ref_deliveryslip: "",
    auth_ref_itemprice: "",
    auth_ref_invoice: "",
    auth_ref_printableitem: "",
    auth_ref_estimate: "",
    auth_ref_samplecatalogue: "",
    auth_ref_envdocument: "",
    auth_ref_parametersheet: "",
    auth_ref_npc: "",
    auth_item_datasheet: "",
    auth_item_catalogue: "",
    auth_item_userexample: "",
    auth_item_consolidation: "",
    auth_item_printableitem: "",
    auth_item_envdocument: "",
    auth_mail_deliverydate: "",
    auth_mail_deliveryslip: "",
    auth_mail_invoice: "",
    auth_ref_contacthistory: ""
  }
});

export const mutations = {
  setError: message => {
    store.noError = false;
    store.errorMessage = message;
  },
  setUserInfo: info => {
    store.info = { ...info };
  }
};
